module.exports = __webpack_public_path__ + "media/site_templates/www.hirelocalplumbers.com.au/images/splash-212f7b1c3f6cfc896fcd05e2eb55c797.jpeg";